import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from 'handlebars';


Snappy.Component.DisciplinarySearch = class DisciplinarySearch extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-disciplinary-search';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
    }

    setVars() {
        this.$forms =  this.$element.find('.js-search-form');
        this.$resultCounter =  this.$element.find('.js-result-cout');
        this.$tabLinks =  this.$element.find('.js-disciplinary-tab');
        this.$hiddenResults = $("#hiddenresult");
        this.$results = $("#results");
        this.$preloaderContainer = this.$element.find('.js-preloader-container');
        this.simpleTemplate = Handlebars.compile($('#simple-template').html());
        this.documenntsearch = Handlebars.compile($('#documenntsearch').html());

        this.state = {
            isAjaxInProgress: false,
            isResponseReceived: false,
            isZeroResults: false
        }

    }

    setEventListeners() {
        this.$forms.on('submit', this.onSubmit.bind(this));
        this.$tabLinks.on('click', this.onTabChange.bind(this));
    }

    onSubmit(e) {
        e.preventDefault();

        let $form = $(e.target);
        let handler =  $form.attr('data-handler');
        let query = $form.serialize();
        let url = handler + '?' + query;


        this.state.isAjaxInProgress = true;
        this.updateDomToState();

        this.$preloaderContainer.addClass('cfa-preloader--active');

        $.get( url, ( data ) => {
           
            if (typeof data === 'object') {

                this.$resultCounter.text(data.length);
                let resultHTML = '';
                
                if (handler.search("SearchDocsDisciplineCases") != -1) {
                    resultHTML = this.documenntsearch({objects: data});

                }
                else {
                     resultHTML = this.simpleTemplate(data);
                }

                this.$hiddenResults.html(resultHTML);

                // legacy code here
                initPagination();
            }

            if ( typeof data === 'string' ) {
                // because we have HTML here from backend side
                this.$results.html(data);
                this.$resultCounter.text( this.$results.find('.mod-newsList li').length );
                $("#pagination").empty();
            }

            this.$preloaderContainer.removeClass('cfa-preloader--active');
            this.state.isAjaxInProgress = false;
            this.state.isResponseReceived = true;
            this.state.isZeroResults = (data.length === 0);
            this.updateDomToState();
        })
    }

    onTabChange (e) {

        this.clearResults();

        this.state.isAjaxInProgress = false;
        this.state.isResponseReceived = false;
        this.state.isZeroResults = false;
        this.updateDomToState();

        if ($(e.target).data('name') === 'key-cases') {
            let keyCasesForm = this.$forms.filter('[data-name="key-cases"]');

            keyCasesForm.submit();
        }

    }

    clearResults() {
        this.$results.empty();
        this.$hiddenResults.empty();

    }

    updateDomToState() {

        this.$element[(this.state.isAjaxInProgress) ? "addClass" : "removeClass"]("is-ajax-progress");
        this.$element[(this.state.isResponseReceived) ? "addClass" : "removeClass"]("is-response-received");
        this.$element[(this.state.isZeroResults) ? "addClass" : "removeClass"]("is-zero-results");

    }



};





// WEBPACK FOOTER //
// ./components/disciplinary-search/scripts/disciplinary-search.js